import { Component, OnDestroy } from '@angular/core';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-dash-widget-base',
  template: '',
})
export abstract class DashboardWidgetBaseComponent implements OnDestroy {
  readonly subscriptions = new Subscription();
  isLoading: boolean = true;

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }
}
